import { Tweet } from '@pauliescanlon/gatsby-mdx-embed';
import ShortcutDisplay from "../../../../src/components/ShortcutDisplay";
import outline from "../../../../assets/images/docs/outline.png";
import * as React from 'react';
export default {
  Tweet,
  ShortcutDisplay,
  outline,
  React
};